import {useState,useEffect} from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import useMarketPlaceVerificationStatus from '../../../hooks/useMarketPlaceVerificationStatus';
const BASE_URL = process.env.REACT_APP_BASE_URL;
const UniversityAnnouncements = () => {
  const navigate = useNavigate()
   const { isVerified } = useMarketPlaceVerificationStatus();
   const [announcements, setAnnouncements] = useState([]);
        const fetchAnnouncements = async () => {
          try {
            const res = await axios.get(
              `${BASE_URL}/marketplace/university/announcements/public/`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                  "x-api-key": process.env.REACT_APP_X_API_KEY,
                },
              }
            );
            //  console.log("The announcements are:",res)
            setAnnouncements(res?.data || []);
          } catch (error) {
            console.log("Error while getting profiles", error);
            setAnnouncements([]);
          }
        };
      
        useEffect(() => {
          fetchAnnouncements();
        }, []);
      
  return (
    <div className=" flex flex-col gap-4 flex-1 w-full">
       <section className="
    w-full
    rounded-2xl border border-gray-200
    bg-white
    p-6
    shadow-sm
    transition-all duration-200
    hover:shadow-md
    hover:border-gray-300
  ">
     <div className="flex items-center gap-3 p-4 bg-[#e8f0f7] rounded-xl mb-6">
  <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
    <svg
  className="w-5 h-5 text-[#0f6abf]"
  fill="none"
  stroke="currentColor"
  viewBox="0 0 24 24"
>
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0a3 3 0 11-6 0"
  />
</svg>
  </div>
  <div className="flex-1 min-w-0">
  <div className="flex items-center gap-2 flex-wrap">
    <div className="text-sm font-semibold text-gray-900 break-words">
      Announcements
    </div>
    <div className="text-xs text-gray-500 break-words">
      University ↔ Industry
    </div>
  </div>
</div>

</div>
     {
  announcements.map((p, i) => (
    <div
      key={i}
      className="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-4 cursor-pointer hover:border-[#0f6abf] transition-colors"
    //   onClick={() =>{
    //   window.history.pushState({}, "", `/marketplace/independent_researcher/post/${p.id}?research_type=${p.research_type}&type=${p.publication_type}`);
    //   setType(p?.publication_type)
    //   setSearchType(p?.research_type) 
    //   setPostId(p?.id)
    //   setOpen(true)
    // }}
    >
      <div className="opp-header mb-4">
                  {/* First Row: Badge and Profile */}
                  <div className="flex items-center justify-between mb-3">
                    {/* Left: Badge */}
                    <div className="bg-[#e8f0f7] border border-[#0f6abf] text-[#0f6abf] text-xs font-semibold inline-block rounded-lg py-1 px-3">
                      {p?.university_data?.university_name}
                    </div>
                    {/* <div className="flex items-center gap-1 text-gray-600 text-sm">
                      <Eye className="w-4 h-4" />
                      <span>{p?.views}</span>
                    </div> */}
                    {/* Right: Profile Section */}
                    <div
                      className="flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity"
                    >
                     
                        <img
                           src={p?.university_data ? p?.university_data.university_logo : p?.profile_data?.profile_picture}
                    alt="University"
                          className="w-8 h-8 rounded-full object-cover border border-gray-300"
                          onClick={(e)=>{
                         if(isVerified)
                         {
                            e.stopPropagation()
                       navigate(p?.university_data ? `/marketplace/university/${p?.university_data?.id}` : `/marketplace/independent_researcher/${p?.researcher}`)
                         }
                    }}
                        />
                    </div>
                  </div>
                   <div className="text-lg text-gray-900 mb-2 mt-2 font-bold" >
                  {p?.title}  
                </div>
                   <p
  className="text-sm text-gray-600 mt-2 flex-grow"
  dangerouslySetInnerHTML={{ __html: p?.description }}
/>
 {/* <div className="p-1  cursor-pointer transition-all duration-200 hover:shadow-md">

  <div className="flex flex-wrap gap-2">
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {p?.domain}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-100">
      {p?.collaboration}
    </span>

    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {p?.maturity}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-green-50 text-green-600 border border-green-100">
      {p?.visibility}
    </span>
  </div>
</div> */}
  <div className="w-full mt-4">
                      {/* Media Preview */}
              {p.announcement_type === "image" && (
                <img
                  src={p.file}
                  alt={p.name}
                  className="w-full h-48 object-cover"
                />
              )}
              {p.announcement_type === "pdf" && (
                <iframe
                  src={`${p.file}#toolbar=0`}
                  title={p.name}
                  className="w-full h-48"
                />
              )}
              {(p.announcement_type === "doc" || p.type === "docx") && (
                <iframe
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(
                    p.file
                  )}&embedded=true`}
                  title={p.name}
                  className="w-full h-48"
                />
              )}
              {p.announcement_type === "video" && (
                <video
                  src={p.file}
                  controls
                  className="w-full h-48 object-cover"
                />
              )}
              {p.announcement_type === "audio" && (
                <div className="w-full h-48 flex items-center justify-center bg-gray-100">
                  <audio src={p.file} controls className="w-full px-4" />
                </div>
              )}
                </div>
                  {/* Second Row: Reads and Date */}
                  {/* <div className="flex items-center justify-between">
                   
                    <div className="flex items-center gap-1 text-gray-600">
                      <img className="w-4 h-4" src={ReadIcon} alt="Read Icon" />
                      <span className="text-xs font-medium">{p.reads ?? 0}</span>
                    </div>

                   
                    <div className="text-xs text-gray-500 whitespace-nowrap">
                      {new Date(p.created_at).toLocaleDateString()}
                    </div>
                  </div> */}
                </div>
    </div>
  ))
}
  </section>

    </div>
  )
}

export default UniversityAnnouncements
